import { t } from "i18next";
import * as Yup from 'yup';


export function getOrganisationValidationScheme() {
    return Yup.object().shape({
        name: Yup.string().required(t('Required')),
        address: Yup.string().max(100, t("Max characters exceeded", { max: 100 })),
        cvr: Yup.string().max(100, t("Max characters exceeded", { max: 100 })),
        comment: Yup.string().max(1000, t("Max characters exceeded", { max: 1000 })),
        invoice: Yup.object().shape({
            email: Yup.string().max(100, t("Max characters exceeded", { max: 100 })),
            reference: Yup.string().max(100, t("Max characters exceeded", { max: 100 })),
            debitor: Yup.string().max(100, t("Max characters exceeded", { max: 100 })),
            note: Yup.string().max(1000, t("Max characters exceeded", { max: 1000 }))
        }),
    })
}
